import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';

import { toastError, toastSuccess } from '@components/Toast';

import { supplierTypeWiseFieldParams } from '@features/filter/static/filterUtil';

import { fetchSupplierTypeWiseList } from '@store/actions/SupplierAction';
import { fetchEnumFilter } from '@store/design/action';
import { getEnumFilter } from '@store/reducers';

import ApiClient from '@lib/apiClient';

import { validateFloatNumber } from '@utils/Util';

const TagMaterials = ({ show, handleClose, id, materialId, supplierType, materialInfo = null }) => {
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [priceType, setPriceType] = useState(null);
	const [capacityType, setCapacityType] = useState(null);
	const [price, setPrice] = useState('');
	const [capacity, setCapacity] = useState('');
	const [leadTimeInDays, setLeadTimeInDays] = useState('');
	const [itemRating, setItemRating] = useState('');
	const [moq, setMoq] = useState('');
	const [description, setDescription] = useState('');
	const [errors, setErrors] = useState({});
	const filterFields = useSelector((store) => store.filterFieldStore);
	const dispatch = useDispatch();

	let allUnitTypes = useSelector(getEnumFilter);

	useEffect(() => {
		dispatch(fetchEnumFilter('info.nitex.app.materials.UnitType'));
	}, []);

	useEffect(() => {
		if (materialInfo !== null) {
			setCapacity(materialInfo.capacity);
			setMoq(materialInfo.moq);
			setLeadTimeInDays(materialInfo.leadTimeInDays);
			setPriceType(materialInfo.pricePerUnit);
			setCapacityType(materialInfo.capacityUnit);
			setItemRating(materialInfo.itemRating);
			setDescription(materialInfo.description);
			setPrice(materialInfo.price);
		}
	}, [materialInfo]);

	const onPriceType = (type) => setPriceType(type);

	const onCapacityType = (type) => setCapacityType(type);

	const onSubmit = async () => {
		if (price === null) {
			setErrors({ ...errors, priceError: 'Price is required' });
			return;
		}
		if (priceType === null) {
			setErrors({ ...errors, priceUnitError: 'Price unit is required' });
			return;
		}
		if (capacity === null) {
			setErrors({ ...errors, capacityError: 'Capacity is required' });
			return;
		}
		if (capacityType === null) {
			setErrors({ ...errors, capacityUnitError: 'Capacity unit is required' });
			return;
		}
		setIsSubmitLoading(true);
		await ApiClient.POST('addSupplierMaterialtag', {
			price: price ? price : null,
			leadTimeInDays: leadTimeInDays ? leadTimeInDays : null,
			capacity: capacity ? capacity : null,
			capacityUnit: capacityType,
			pricePerUnit: priceType,
			itemRating,
			moq: moq ? moq : null,
			description,
			materialId,
			supplierId: id,
			requestedPage: 'SUPPLIER'
		})
			.then(({ data }) => {
				setIsSubmitLoading(false);
				if (data && data.success) {
					dispatch(
						fetchSupplierTypeWiseList(id, supplierTypeWiseFieldParams(supplierType, filterFields))
					);
					toastSuccess(data.message);
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsSubmitLoading(false);
				handleClose();
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	return (
		<Modal show={show} onHide={handleClose} centered className="width-784-popup">
			<div className="common-popup width-784 additional-info-popup">
				<Modal.Header closeButton>
					<Modal.Title>
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">Additional information</h3>
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="common-popup-body">
						<div className="container px-0">
							<div className="row">
								<div className="col-md-4 mb-3">
									<div className="input-group mb-0">
										<label htmlFor="price">Price*</label>
										<input
											type="text"
											autoComplete="off"
											id="price"
											className="form-control"
											aria-label="Text input with dropdown button"
											placeholder="$"
											value={price}
											onChange={(e) => setPrice(e.target.value)}
											onKeyPress={validateFloatNumber}
										/>

										<div className="input-group-append">
											<button
												className="btn btn-outline-secondary dropdown-toggle"
												type="button"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												{priceType ? priceType : 'Unit'}
											</button>
											<div
												className="dropdown-menu"
												x-placement="bottom-start"
												style={{
													position: 'absolute',
													willChange: 'transform',
													top: 0,
													left: 0,
													transform: 'translate3d(381px, 36px, 0px)'
												}}
											>
												{allUnitTypes?.unitType?.map((item) => (
													<span
														key={item.name}
														className="dropdown-item"
														value={item.name}
														onClick={() => onPriceType(item.constant)}
													>
														{item.name}
													</span>
												))}
											</div>
										</div>
									</div>
									<>
										{errors.priceError && (
											<p className="error w-100">{errors.priceError}</p>
										)}
										{errors.priceUnitError && (
											<p className="error w-100">{errors.priceUnitError}</p>
										)}
									</>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<label htmlFor="lead">Lead time</label>
										<input
											type="number"
											id="lead"
											placeholder="Days"
											value={leadTimeInDays}
											onChange={(e) =>
												setLeadTimeInDays(
													e.target.value === '' ? null : e.target.value
												)
											}
										/>
									</div>
								</div>
								<div className="col-md-4 mb-3">
									<div className="input-group mb-0">
										<label htmlFor="Capacity">Capacity/day*</label>
										<input
											type="number"
											id="Capacity"
											className="form-control"
											aria-label="Text input with dropdown button"
											value={capacity}
											onChange={(e) => setCapacity(e.target.value)}
										/>
										<div className="input-group-append">
											<button
												className="btn btn-outline-secondary dropdown-toggle"
												type="button"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												{capacityType ? capacityType : 'Unit'}
											</button>
											<div
												className="dropdown-menu"
												x-placement="bottom-start"
												style={{
													position: 'absolute',
													willChange: 'transform',
													top: 0,
													left: 0,
													transform: 'translate3d(381px, 36px, 0px)'
												}}
											>
												{allUnitTypes?.unitType?.map((item) => (
													<span
														key={item.name}
														className="dropdown-item"
														value={item.name}
														onClick={() => onCapacityType(item.constant)}
													>
														{item.name}
													</span>
												))}
											</div>
										</div>
									</div>
									<>
										{errors.capacityError && (
											<p className="error w-100">{errors.capacityError}</p>
										)}
										{errors.capacityUnitError && (
											<p className="error w-100">{errors.capacityUnitError}</p>
										)}
									</>
								</div>
								<div className="col-md-6">
									<div className="form-group ">
										<label htmlFor="rating">Item rating</label>
										<select
											className="w-100"
											name="rating"
											id="rating"
											value={itemRating}
											onChange={(e) => setItemRating(e.target.value)}
										>
											<option value={null}>Select</option>
											<option value={1}>1</option>
											<option value={2}>2</option>
											<option value={3}>3</option>
											<option value={4}>4</option>
											<option value={5}>5</option>
										</select>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group">
										<label htmlFor="MOQ">MOQ</label>
										<input
											type="number"
											id="MOQ"
											value={moq}
											onChange={(e) => setMoq(e.target.value)}
										/>
									</div>
								</div>
								<div className="col-md-12">
									<div className="form-group mb-0">
										<label htmlFor="description">Description</label>
										<textarea
											name="description"
											id="description"
											placeholder="Write description"
											value={description}
											onChange={(e) => setDescription(e.target.value)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="footer-buttons text-right">
						<button className="button outline size32" onClick={handleClose}>
							Cancel
						</button>
						<button
							disabled={isSubmitLoading}
							className="button size32 ml-2"
							onClick={() => onSubmit()}
						>
							Submit
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default TagMaterials;
